import { render } from "./Contato.vue?vue&type=template&id=6c45b8cc&scoped=true"
import script from "./Contato.vue?vue&type=script&lang=js"
export * from "./Contato.vue?vue&type=script&lang=js"

import "./Contato.vue?vue&type=style&index=0&id=6c45b8cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c45b8cc"]])

export default __exports__